export default {
      id: "search-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }